import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { s as spinner, c as check, e as exclamationTriangle, i as infoCircle, a as exclamation, d as close } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';
import { I as Icon } from '../Icon/Icon-C7C24ly7.js';
import { T as Text } from '../Text/Text-DSyBMYfT.js';
import { I as IconButton } from '../Button/IconButton/IconButton-nX72Aute.js';

const typeIconMap = {
  error: exclamation,
  info: infoCircle,
  warning: exclamationTriangle,
  success: check,
  loading: spinner
};
const SnackbarContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40017521__sc-11vt7q0-0"
})(["display:flex;align-items:flex-start;border-radius:", ";box-shadow:", ";background-color:", ";max-width:", ";gap:", ";padding-block:", ";padding-inline:", ";", ""], ({
  theme
}) => theme.border.radius.large, ({
  theme
}) => theme.elevation.shadow.overlay, ({
  theme,
  $supportType
}) => {
  if ($supportType) {
    var _theme$support$backgr;
    return (_theme$support$backgr = theme.support.backgroundColor[$supportType]) !== null && _theme$support$backgr !== void 0 ? _theme$support$backgr : theme.surface.default;
  }
  return theme.surface.default;
}, ({
  theme
}) => theme.snackbar.maxWidth.default, ({
  theme
}) => theme.spacing.xsmall.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.xsmall.default, isMobile(css(["max-width:", ";gap:", ";padding-block:", ";padding-inline:", ";"], ({
  theme
}) => theme.snackbar.maxWidth.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile, ({
  theme
}) => theme.spacing.small.mobile, ({
  theme
}) => theme.spacing.xsmall.mobile)));
const TextContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40017521__sc-11vt7q0-1"
})(["flex:1;min-height:", ";align-items:center;display:flex;"], ({
  theme
}) => theme.controls.height.base.default);

// @TODO: (storm-v4) revise after Icon update (remove snackbar.icon.size)
const IconWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40017521__sc-11vt7q0-2"
})(["display:flex;align-items:center;justify-content:center;color:", ";height:", ";width:", ";", ""], ({
  theme,
  $supportType
}) => {
  if ($supportType) {
    var _theme$support$iconCo;
    return (_theme$support$iconCo = theme.support.iconColor[$supportType]) !== null && _theme$support$iconCo !== void 0 ? _theme$support$iconCo : theme.text.color.default;
  }
  return theme.text.color.default;
}, ({
  theme
}) => theme.controls.height.base.default, ({
  theme
}) => theme.icon.size.xlarge.default, isMobile(css(["width:", ";"], ({
  theme
}) => theme.icon.size.xlarge.mobile)));
const Snackbar = /*#__PURE__*/forwardRef(({
  children,
  closeButtonLabel = 'Dismiss',
  id,
  onClose,
  variant,
  ...rest
}, ref) => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/React__default.createElement(SnackbarContainer, _extends({}, rest, {
    id: id,
    ref: ref,
    role: onClose ? 'alertdialog' : 'alert',
    $supportType: variant
  }), variant && typeIconMap[variant] && /*#__PURE__*/React__default.createElement(IconWrapper, {
    $supportType: variant
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: typeIconMap[variant],
    size: "xlarge"
  })), /*#__PURE__*/React__default.createElement(TextContainer, null, /*#__PURE__*/React__default.createElement(Text, {
    renderAs: "span"
  }, children)), onClose && /*#__PURE__*/React__default.createElement(IconButton, {
    id: `${id}-dismiss-button${isMobile ? '-mobile' : ''}`,
    onClick: onClose,
    label: closeButtonLabel,
    icon: close,
    variant: "transparent"
  }));
});

export { Snackbar as S };
//# sourceMappingURL=Snackbar-DfcVztPe.js.map
